export enum PaymentMethodEnum {
  Card = 'card',
  PayPal = 'paypal',
  ApplePay = 'applepay'
}
